<template>
  <v-container fluid class="price-page">
    <!-- Alert Banner -->
    <AAlertBanner variant="danger" :messages="alertError" title="Warning" :icon-size="22" />

    <!-- Header -->
    <div class="price-header">
      <div class="price-header__top">
        <div class="price-header__info">
          <h1 class="price-header__title">Price Setting</h1>
        </div>
      </div>
    </div>

    <!-- Tabs Section -->
    <div class="section-card">
      <v-tabs vertical class="price-tabs">
        <v-tab class="price-tab">
          <v-icon left size="18">mdi-percent</v-icon>
          Tax Rate
        </v-tab>

        <v-tab-item>
          <v-card flat class="price-tab-content">
            <component
              :is="taxRateTab"
              :params="params"
              @toggleTaxRatePage="toggleTaxRatePage"
            ></component>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>

    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from "@/objects/api";
import { mapState } from "vuex";
import Model from "@/objects/model";
import TaxRateAdd from "./taxrate/Add";
import Service from "@/objects/service";
import TaxRateIndex from "./taxrate/Index";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc_event/objects/globalData";

export default {
  mixins: [hrdcFunction],
  components: {
    TaxRateIndex,
    TaxRateAdd,
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  props: ["params"],
  data: () => ({
    apiGetApplicationSingleDetail: new Api(),
    apiSubmit: new Api(),
    model: new Model(),
    service: new Service(),
    hrdcData: new HrdcData(),
    alertError: [],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    formData: {
      applicationNo: null,
    },
    errorField: {
      applicationNo: null,
    },
    loadingDialog: false,
    btnDisabled: false,
    taxRateTab: "TaxRateIndex",
  }),
  watch: {
    //
  },
  async created() {
    this.loadingDialog = !this.loadingDialog;
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiSubmit: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/claim_approved/update-claim-approved`,
        method: "post",
      },
      apiGetApplicationSingleDetail: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-single-application`,
        method: "post",
        params: {
          applicationUuid:
            this.$store.state[this.service.key].data.applicationUuid,
        },
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    this.stages = await this.hrdcData.allStages;
    this.rolesAssignation(this.auth.roles);
    // if (!this.isTaxpodAdminRoles) {
    //   this.alertError.push("You are not allowed to perform this action!");
    //   this.btnDisabled = true;
    // }
    this.loadingDialog = !this.loadingDialog;
  },
  mounted() {},
  methods: {
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = null;
        this.errorField[key] = response.data[key];
      }
    },
    //EOC
    redirectBack() {
      let route = this.eventRoute("Settings");
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
      });
    },
    toggleTaxRatePage(redirectToComponent) {
      this.taxRateTab = redirectToComponent;
    },
    async submit() {
      this.loadingDialog = !this.loadingDialog;
      let data = {
        applicationUuid: this.formData.applicationNo,
        claimApprovedDate: this.formData.claimApprovedDate,
        referById: this.auth.uuid,
        editMode: this.editMode,
      };

      this.apiSubmit.setParams(data);
      this.apiSubmit.fetch();
      this.apiSubmit.setCallbackCompleted((response) => {
        try {
          this.clearErrorMsg();
          this.loadingDialog = !this.loadingDialog;
          if (!response.status) {
            this.showErrorMessage(response);
            this.$store.dispatch("showMessage", {
              message: response.message,
              messageType: "error",
              timeout: 2000,
            });
          }

          if (response.status) {
            this.$store.commit("assignDeveloperData", {
              paginationPageNo: this.$route.query.currentPageNo,
            });

            this.$router.push({
              name: this.eventRoute("Application"),
              query: {
                viewId: this.$store.state[this.service.key].data.viewId,
              },
            });
            this.$store.dispatch("showMessage", {
              message: response.data,
              messageType: "success",
              timeout: 2000,
            });
          }
        } catch (err) {
          console.log(err);
        }
      });
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .price-page {
  background-color: var(--app-page);
}

.dark-mode .price-header {
  background: var(--app-elevated);
}

.dark-mode .back-btn {
  background: var(--app-card);
  border: 1px solid var(--app-border-strong);
}

.dark-mode .back-btn:hover {
  background: var(--app-surface);
  border-color: var(--app-border-strong);
}

.dark-mode .section-card {
  background: var(--app-elevated);
}

.dark-mode .price-tab-content {
  background: var(--app-card) !important;
}

/* >>> end auto-dark <<< */

/* ============================================
   PAGE WRAPPER
   ============================================ */
.price-page {
  background-color: #d8dce2;
  /* Fills main minus the breadcrumb and footer; a `100vh - 64px` guess only
     subtracts the app bar and overflows. See .layout-main__content. */
  flex: 1 0 auto;
  padding-top: 24px !important;
  padding-bottom: 60px !important;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ============================================
   HEADER
   ============================================ */
.price-header {
  background: #eaecef;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  margin-bottom: 24px;
  overflow: hidden;
}

.price-header__top {
  display: flex;
  align-items: center;
  padding: 24px 28px;
}

.back-btn {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #d1d5db;
  cursor: pointer;
  margin-right: 16px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.price-header__info {
  flex: 1;
  min-width: 0;
}

.price-header__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #3a3f47;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: -0.2px;
}

/* ============================================
   SECTION CARD & TABS
   ============================================ */
.section-card {
  background: #eaecef;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  margin-bottom: 24px;
}

.section-card:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}

.price-tab-content {
  background: #fff !important;
}

/* ============================================
   TRANSITIONS
   ============================================ */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 959px) {
  .price-header__top {
    padding: 16px 20px;
  }
}
</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .price-tabs .v-slide-group__content {
  border-right: 1px solid var(--app-border);
  background: var(--app-surface);
}

.dark-mode .price-tabs .v-tab {
  color: var(--app-text-muted) !important;
}

.dark-mode .price-tabs .v-tab:hover {
  background: var(--app-elevated) !important;
  color: var(--app-text) !important;
}

.dark-mode .price-tabs .v-tab--active {
  background: var(--app-accent-soft) !important;
}

/* >>> end auto-dark <<< */

.price-tabs .v-slide-group__content {
  border-right: 1px solid #e2e8f0;
  background: #f8fafc;
}

.price-tabs .v-tab {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  color: #64748b !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  justify-content: flex-start !important;
  padding: 0 20px !important;
  min-height: 48px !important;
  transition: all 0.15s ease;
}

.price-tabs .v-tab:hover {
  background: #eef2f7 !important;
  color: #334155 !important;
}

.price-tabs .v-tab--active {
  background: #e0f2fe !important;
  color: #0369a1 !important;
  font-weight: 700 !important;
}

.price-tabs .v-tab--active::before {
  opacity: 0 !important;
}

/* ============================================
   DARK MODE
   ============================================ */
.dark-mode .price-page { background-color: var(--app-page); }
.dark-mode .price-header { background: var(--app-card); }
.dark-mode .price-header__title { color: var(--app-text); }
.dark-mode .back-btn { background: var(--app-page); border-color: var(--app-border); }
.dark-mode .back-btn:hover { background: var(--app-card); }
.dark-mode .section-card { background: var(--app-card); }
.dark-mode .price-tabs .v-slide-group__content { background: var(--app-page); border-color: var(--app-border); }
.dark-mode .price-tabs .v-tab { color: var(--app-text-muted) !important; }
.dark-mode .price-tabs .v-tab:hover { background: var(--app-card) !important; }
.dark-mode .price-tabs .v-tab--active { background: var(--app-accent-soft) !important; color: var(--app-accent) !important; }
.dark-mode .price-tab-content { background: var(--app-card) !important; }
</style>
